export default __webpack_public_path__ + "static/media/norfund.03debb4a.png";